import { render, staticRenderFns } from "./LeaveComment.vue?vue&type=template&id=406be71b&"
import script from "./LeaveComment.vue?vue&type=script&lang=js&"
export * from "./LeaveComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports